import VoicesContainer from './VoicesContainer';
export default VoicesContainer;
